// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__QDxpu","row":"Tooltip_row__xVgDO","label":"Tooltip_label__V23GJ","value":"Tooltip_value__YvBp0"};